// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"978":"03f413fb","2773":"2a780fac","2940":"0f90a982","3823":"f8e4382e","4950":"2a780fac"}[chunkId] + ".chunk.css";
};